import { render, staticRenderFns } from "./BookingnoOverview.vue?vue&type=template&id=56ddf669&scoped=true"
import script from "./BookingnoOverview.vue?vue&type=script&lang=js"
export * from "./BookingnoOverview.vue?vue&type=script&lang=js"
import style0 from "./BookingnoOverview.vue?vue&type=style&index=0&id=56ddf669&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ddf669",
  null
  
)

export default component.exports